import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-alarmLogol",
  "use": "icon-alarmLogol-usage",
  "viewBox": "0 0 19.998 20.004",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.998 20.004\" id=\"icon-alarmLogol\"><path data-name=\"减去 21\" d=\"M13.998 20.002h-8a6.007 6.007 0 0 1-6-6v-8a6.007 6.007 0 0 1 6-6h8a6.007 6.007 0 0 1 6 6v8a6.007 6.007 0 0 1-6 6zm-4.4-6.338a1.36 1.36 0 0 0-1.395 1.389 1.379 1.379 0 0 0 1.295 1.295 1.5 1.5 0 0 0 1.389-1.391 1.4 1.4 0 0 0-1.289-1.291zm-.5-10.238a1.417 1.417 0 0 0-1.6 1.391l.6 6.264a1.23 1.23 0 0 0 1.193 1.289h.4a1.23 1.23 0 0 0 1.193-1.289l.7-6.264a1.419 1.419 0 0 0-1.59-1.391z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol